<template>
    <AdminPageInner v-if="sessionGroup.id" :breadcrumbs="breadcrumbs">
        <template #heading>Create application</template>
        <CourseApplicationForm @submit="onSubmit">
            <template #footer>
                <div class="flex flex-row-reverse items-center">
                    <SubmitButton
                        :submitting="form.processing"
                        :disabled="form.errors.any()">
                        Create
                    </SubmitButton>
                    <router-link :to="redirectRoute" class="text-gray-500 mr-4">
                        Cancel
                    </router-link>
                </div>
            </template>
        </CourseApplicationForm>
        <Modal v-model:show="showConfirmationModal">
            <div class="px-4 py-6">
                <p class="mb-6 text-lg text-gray-700">
                    This course has already started. Are you sure you want to continue?
                </p>
                <div class="flex flex-col justify-between items-center sm:flex-row-reverse mt-6">
                    <Button
                        class="w-full sm:w-auto"
                        @click.prevent="showConfirmationModal = false">
                        Continue
                    </Button>
                    <router-link
                        :to="{
                        name: 'admin.courses.session-groups.applications.index',
                        params: this.$route.params
                    }"
                        class="inline-block mt-4 underline text-sm text-gray-600 hover:text-gray-900 sm:mt-0 sm:mr-auto">
                        Cancel
                    </router-link>
                </div>
            </div>
        </Modal>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import CourseApplicationForm from "@/Pages/Admin/CourseApplications/Components/Form";
import SubmitButton from "@/Components/Form/SubmitButton";
import {CourseApplicationStatus as ApplicationStatus} from "@/Lib/Enums";
import Modal from "@/Components/Modal";
import Button from "@/Components/Button";

export default {

    name: "CourseApplicationCreatePage",

    data() {
        return {
            course: {},
            sessionGroup: {},
            form: this.$form({
                course_session_group_id: this.$route.params.courseSessionGroupId,
                user_id: null,
                status: ApplicationStatus.Pending
            }),
            showConfirmationModal: false
        }
    },

    provide() {
        return {
            form: this.form,
        }
    },

    components: {
        AdminPageInner,
        CourseApplicationForm,
        SubmitButton,
        Modal,
        Button
    },

    methods: {
        setData({course, sessionGroup}) {
            this.course = course;
            this.sessionGroup = sessionGroup;

            if (sessionGroup.started) {
                this.showConfirmationModal = true;
            }
        },
        onSubmit() {

            if (this.form.processing) {
                return;
            }
            this.form.post(route('api.course-applications.store'))
                .then(() => {
                    this.$notify.success('Record created');
                    this.$router.push(this.redirectRoute);
                })
                .catch(console.error);
        },
    },

    computed: {
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Session Groups`,
                    to: {name: 'admin.courses.session-groups.index', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Group`,
                    to: {
                        name: 'admin.courses.session-groups.show',
                        params: {
                            courseId: this.$route.params.courseId,
                            courseSessionGroupId: this.$route.params.courseSessionGroupId
                        }
                    }
                },
                {
                    label: `Applications`,
                    to: {
                        name: 'admin.courses.session-groups.applications.index',
                        params: this.$route.params
                    }
                },
                {
                    label: `Create`, to: {name: this.$route.name, params: this.$route.params}
                },
            ];
        },
        redirectRoute() {
            return this.$route.meta.previous
                ? this.$route.meta.previous
                : {
                    name: 'admin.courses.session-groups.applications.index',
                    params: this.$route.params
                };
        }
    },

    async beforeRouteEnter(to, from, next) {
        const responses = await Promise.all([
            axios.head(route('api.course-applications.create')),
            axios.get(route('api.courses.show', to.params.courseId)),
            axios.get(route('api.course-session-groups.show', to.params.courseSessionGroupId)),

        ])

        next(vm => vm.setData({
            course: responses[1].data,
            sessionGroup: responses[2].data,
        }));
    },
};

</script>
